import { Button, Input, Form, message, Tooltip } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import { CloseOutlined, DeleteOutlined, FileImageOutlined } from "@ant-design/icons";

import endpoints from "../../utils/endpoints.js";
import config from "../../utils/config.js";

import Media from "../../components/Media/media.js";

function SettingsSponsor({ data }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [mediaKey, setMediaKey] = useState(null);
  const [mediaKeyInd, setMediaKeyInd] = useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    if (data.length > 0) {
      let auxData = Object.assign([], data).filter((item) => item.name === "sponsor")[0];
      form.setFieldsValue(JSON.parse(auxData.json));
    }
  }, [data]);

  function handleSubmit(values) {
    setIsButtonLoading(true);

    axios
      .post(endpoints.settings.update, {
        data: { values, name: "sponsor" },
      })
      .then((res) => {
        setIsButtonLoading(false);
        message.success("Definições foram editadas com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function handleWarningMissingFields() {
    message.error("Faltam alguns campos para preencher!");
  }

  function openMedia(k, i) {
    setMediaKey(k);
    if (i !== null || i !== undefined) setMediaKeyInd(i);
    setIsOpenMedia(true);
  }

  function closeMedia(res) {
    if (res) {
      if (mediaKeyInd !== null) form.setFieldValue([mediaKey, mediaKeyInd, "img"], res[mediaKey]);
      else form.setFieldValue(mediaKey, res[mediaKey]);
    }

    setMediaKey(null);
    setMediaKeyInd(null);
    setIsOpenMedia(false);
  }

  return (
    <div className="dashboard-page">
      <Media mediaKey={mediaKey} open={isOpenMedia} close={closeMedia} />
      <div className="dashboard-content-row">
        <Form form={form} id="add-commission_type-form" layout="vertical" onFinish={handleSubmit} onFinishFailed={handleWarningMissingFields}>
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <Form.Item name="name" label="Nome">
                <Input size="large" />
              </Form.Item>
            </div>
            <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.img !== currentValues.img}>
              {({ getFieldValue }) => {
                return (
                  <div className="relative">
                    <p className="pb-[8px]">Imagem inicial</p>
                    <div
                      className="relative border border-dashed border-gray-300 mb-6 cursor-pointer flex justify-center items-center h-[120px] w-full overflow-hidden"
                      onClick={() => openMedia("img")}
                      style={{
                        backgroundImage: `url(${config.server_ip}media/${getFieldValue("img")})`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                      }}
                    >
                      {!getFieldValue("img") ? (
                        <div className="flex justify-center items-center flex-col p-10">
                          <FileImageOutlined className="text-[30px]" /> <p className="text-[11px] text-center mt-2">Selecionar Imagem</p>
                        </div>
                      ) : null}
                    </div>

                    <Form.Item name={"img"} hidden>
                      <Input />
                    </Form.Item>
                  </div>
                );
              }}
            </Form.Item>
            <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.img_menu !== currentValues.img_menu}>
              {({ getFieldValue }) => {
                return (
                  <div className="relative">
                    <p className="pb-[8px]">Imagem menu</p>
                    <div
                      className="relative border border-dashed border-gray-300 mb-6 cursor-pointer flex justify-center items-center h-[120px] w-full overflow-hidden"
                      onClick={() => openMedia("img_menu")}
                      style={{
                        backgroundImage: `url(${config.server_ip}media/${getFieldValue("img_menu")})`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                      }}
                    >
                      {!getFieldValue("img_menu") ? (
                        <div className="flex justify-center items-center flex-col p-10">
                          <FileImageOutlined className="text-[30px]" /> <p className="text-[11px] text-center mt-2">Selecionar Imagem</p>
                        </div>
                      ) : null}
                    </div>

                    <Form.Item name={"img_menu"} hidden>
                      <Input />
                    </Form.Item>
                  </div>
                );
              }}
            </Form.Item>
            <p>Imagens</p>
            <div className="col-span-2">
              <Form.List name={"banners"}>
                {(fields, { add, remove, move }) => (
                  <div className="p-6 border border-dashed grid grid-cols-2 gap-4 mb-4">
                    {fields.map((field) => (
                      <div>
                        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.banners !== currentValues.banners}>
                          {({ getFieldValue }) => {
                            return (
                              <div className="relative">
                                <div
                                  className="relative border border-dashed border-gray-300 mb-6 cursor-pointer flex justify-center items-center h-[120px] w-full overflow-hidden"
                                  onClick={() => openMedia("banners", field.name)}
                                  style={{
                                    backgroundImage: `url(${config.server_ip}media/${getFieldValue(["banners", field.name, "img"])})`,
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                  }}
                                >
                                  {!getFieldValue(["banners", field.name, "img"]) ? (
                                    <div className="flex justify-center items-center flex-col p-10">
                                      <FileImageOutlined className="text-[30px]" /> <p className="text-[11px] text-center mt-2">Selecionar Imagem</p>
                                    </div>
                                  ) : null}
                                </div>

                                <Form.Item name={[field.name, "img"]} hidden>
                                  <Input />
                                </Form.Item>

                                <div className="absolute top-[-10px] right-[-10px]">
                                  <Tooltip placement="bottom" title={"Apagar item"}>
                                    <Button icon={<DeleteOutlined />} onClick={() => remove(field.name)}></Button>
                                  </Tooltip>
                                </div>

                                <div className="absolute top-[-10px] right-[30px]">
                                  <Tooltip placement="bottom" title={"Remover imagem"}>
                                    <Button icon={<CloseOutlined />} onClick={() => form.setFieldValue(["banners", field.name, "img"], null)}></Button>
                                  </Tooltip>
                                </div>
                              </div>
                            );
                          }}
                        </Form.Item>
                        <div className="flex justify-center items-center">
                          <Form.Item name={[field.name, "link"]} className="!w-full mb-0!">
                            <Input size="large" className="w-full" placeholder="Link..." />
                          </Form.Item>
                        </div>
                      </div>
                    ))}
                    <div
                      className="relative border border-dashed border-gray-300 mb-6 cursor-pointer flex justify-center items-center h-[120px] w-full overflow-hidden"
                      onClick={() => add()}
                    >
                      <p>Adicionar imagem</p>
                    </div>
                  </div>
                )}
              </Form.List>
            </div>
          </div>
          <Button type="primary" size="large" onClick={form.submit} loading={isButtonLoading}>
            Guardar
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default SettingsSponsor;
